var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / AN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-AN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#D6182D",
    mask: "url(#mask-2)",
    x: 10.6666667,
    y: 0,
    width: 6.66666667,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#1425A2",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "11.3333333 11.6666667 10.8619288 11.8047379 11 11.3333333 10.8619288 10.8619288 11.3333333 11 11.8047379 10.8619288 11.6666667 11.3333333 11.8047379 11.8047379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "16.6666667 11.6666667 16.1952621 11.8047379 16.3333333 11.3333333 16.1952621 10.8619288 16.6666667 11 17.1380712 10.8619288 17 11.3333333 17.1380712 11.8047379"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "8.66666667 10.3333333 8.19526215 10.4714045 8.33333333 10 8.19526215 9.52859548 8.66666667 9.66666667 9.13807119 9.52859548 9 10 9.13807119 10.4714045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "19.3333333 10.3333333 18.8619288 10.4714045 19 10 18.8619288 9.52859548 19.3333333 9.66666667 19.8047379 9.52859548 19.6666667 10 19.8047379 10.4714045"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "14 9 13.5285955 9.13807119 13.6666667 8.66666667 13.5285955 8.19526215 14 8.33333333 14.4714045 8.19526215 14.3333333 8.66666667 14.4714045 9.13807119"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAn);
export default __webpack_public_path__ + "static/media/AN.62b7977fbc2025b3825144ebbe202f3b.svg";
export { ForwardRef as ReactComponent };